import { DataBean } from "../DataBean";

export class NationalizationProcessGeneralInfo extends DataBean {
    
    
    

    public async getNationalizationProcessGeneralInfoCatalogPorPropiedades(properties:any,maxRows:any): Promise<any> {
        return this.getCustomService("ProcessContractERP", "java.util.List_getNationalizationProcessGeneralInfoCatalogPorPropiedades_java.util.Map_Number", [properties,maxRows]);
    }

     public async getNationalizationProcessGeneralInfoReport(page:any,rows:any,props:any): Promise<any> {
        return this.getCustomService("ProcessContractERP", "com.advantage.shared.Report_getNationalizationProcessGeneralInfoReport_Number_Number_java.util.Map", [page,rows,props]);
    }

     public async getNationalizationProcessGeneralInfoCatalogPorPropiedad(nombrePropiedad:any,value:any,maxRows:any): Promise<any> {
        return this.getCustomService("ProcessContractERP", "java.util.List_getNationalizationProcessGeneralInfoCatalogPorPropiedad_String_Object_Number", [nombrePropiedad,value,maxRows]);
    }

    public async updateNationalizationProcessGeneralInfo(bean:any): Promise<any> {
        return this.getCustomService("ProcessContractERP", "com.orange.finance.processcontract.bean.NationalizationProcessGeneralInfo_updateNationalizationProcessGeneralInfo_com.orange.finance.processcontract.bean.NationalizationProcessGeneralInfo", 
            [
                {
                    DataBeanProperties:bean,
                    DataBeanName:"com.orange.finance.processcontract.bean.NationalizationProcessGeneralInfo"
                }
            ]);
    }
    public async exportExcelWithDataINVM(id:number): Promise<any> {
        return this.getCustomService("ProcessContractERP", "String_exportExcelWithDataINVM_Long", 
            [
                id
            ]);
    }
    public async exportExcelWithDataEC(id:number): Promise<any> {
        return this.getCustomService("ProcessContractERP", "String_exportExcelWithDataEC_Long", 
            [
                id
            ]);
    }
    public async exportExcelWithDataLC(id:number): Promise<any> {
        return this.getCustomService("ProcessContractERP", "String_exportExcelWithDataLC_Long", 
            [
                id
            ]);
    }
    public async exportExcelWithDataEM(id:number): Promise<any> {
        return this.getCustomService("ProcessContractERP", "String_exportExcelWithDataEM_Long", 
            [
                id
            ]);
    }
    public async exportExcelWithDataDM(id:number): Promise<any> {
        return this.getCustomService("ProcessContractERP", "String_exportExcelWithDataDM_Long", 
            [
                id
            ]);
    }
    public async exportExcelWithDataExportation(id:number): Promise<any> {
        return this.getCustomService("ProcessContractERP", "String_exportExcelWithDataExportation_Long", 
            [
                id
            ]);
    }
   public async ExportExcelWithDataAuxLiq(id:number): Promise<any> {
        return this.getCustomService("ProcessContractERP", "String_ExportExcelWithDataAuxLiq_Long", 
            [
                id
            ]);
    }

     public async ExportExcelWithDataEDD(id:number): Promise<any> {
        return this.getCustomService("ProcessContractERP", "String_ExportExcelWithDataEDD_Long", 
            [
                id
            ]);
    }

}